import { zustandStore } from "../store/zustand.helpers";

export interface WindowState {
    pathname: string;
}

export interface WindowActions {
    setPathname: (pathname: string) => void;
    reset: () => void;
}

export const initialState: WindowState = { pathname: "/" };

export const { store: windowStore } = zustandStore<WindowState, WindowActions>(
    "Window",
    initialState,
    (set) => ({
        setPathname: (pathname: string) =>
            set(() => ({
                pathname,
            })),
        reset: () => set(() => ({ ...initialState })),
    }),
);
